import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PermissionsRoutingModule } from './permissions-routing.module';
import { UserPermissionsComponent } from './user-permissions/user-permissions.component';
import { PermissionsComponent } from './permissions.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { GroupPermissionsComponent } from './group-permissions/group-permissions.component';
import { PermissionsReportComponent } from './permissions-report/permissions-report.component';
import { ComponentRegistrationComponent } from './component-registration/component-registration.component';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { ManageUsersPopupComponent } from './manage-users/manage-users-popup/manage-users-popup.component';
import { ComponentRegistrationPopupComponent } from './component-registration/component-registration-popup/component-registration-popup.component';
import { GroupPermissionsPopupComponent } from './group-permissions/group-permissions-popup/group-permissions-popup.component';
import { ComponentReportComponent } from './component-report/component-report.component';

//Order matters: Angular modules, then 3rd party, then our own modules
@NgModule({
    imports: [
        SharedModule,
        ReactiveFormsModule,//order matters
        PermissionsRoutingModule
    ],
    declarations: [
        PermissionsComponent,
        DashboardComponent,
        UserPermissionsComponent,
        GroupPermissionsComponent,
        PermissionsReportComponent,
        ComponentRegistrationComponent,
        ManageUsersComponent,
        ManageUsersPopupComponent,
        ComponentRegistrationPopupComponent,
        GroupPermissionsPopupComponent,
        ComponentReportComponent
    ]
})
export class PermissionsModule { }
